module.exports = __webpack_public_path__ + "be961f18e329ea23fb1eec8b0cc87886.png";